import { Routes } from '@angular/router';
import { ChangePasswordComponent } from './auth_modules/change-password/change-password.component';
import { AuthGuard } from './core_modules/guards/auth-gaurd';
import { LoginGuard } from './core_modules/guards/login.guard';
import { DynamicSectionFormDemoComponent } from './common_resource_modules/components/form/dynamic-section-form/dynamic-section-form-demo/dynamic-section-form-demo.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home/dashboard',
  },
  {
    path: 'test-component',
    component: DynamicSectionFormDemoComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth_modules/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [LoginGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./feature_modules/feature-routes').then((m) => m.FEATURE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    data: { title: 'Change Password' },
  },
  {
    path: '**',
    redirectTo: 'home/dashboard',
    pathMatch: 'full',
  },
];
